import { getApiBaseUrl } from '@beatq/sdk-client';
import { csrfHeaders, getAccessToken, mapErrorCode } from '@beatq/shared';

type ApiErr = { error?: { code: string; message: string } };

export type AdminRealtimeTicket = {
  ticket: string;
  websocketUrl?: string;
};

/** POST /admin/v1/realtime/connection-tickets — 10-11 */
export async function createAdminRealtimeConnectionTicket(): Promise<unknown> {
  const res = await fetch(`${getApiBaseUrl()}/admin/v1/realtime/connection-tickets`, {
    method: 'POST',
    credentials: 'include',
    body: '{}',
    headers: {
      'content-type': 'application/json',
      ...csrfHeaders(),
      ...(getAccessToken() ? { authorization: `Bearer ${getAccessToken()}` } : {}),
    },
  });
  const json = await res.json().catch(() => null);
  if (!res.ok) {
    const err = json as ApiErr | null;
    throw new Error(err?.error?.message ?? mapErrorCode(err?.error?.code ?? 'ERR-UNKNOWN'));
  }
  return json;
}

/** Parse BE mint envelope: `{ data: { connection: { ticket, websocketUrl } } }` or flat `{ ticket }`. */
export function parseAdminRealtimeTicketEnvelope(envelope: unknown): AdminRealtimeTicket | null {
  if (envelope == null || typeof envelope !== 'object') return null;
  const root = envelope as Record<string, unknown>;
  const data =
    root.data && typeof root.data === 'object' ? (root.data as Record<string, unknown>) : root;
  const connection =
    data.connection && typeof data.connection === 'object'
      ? (data.connection as Record<string, unknown>)
      : data;
  const ticket =
    (typeof connection.ticket === 'string' && connection.ticket) ||
    (typeof connection.token === 'string' && connection.token) ||
    null;
  if (!ticket) return null;
  const websocketUrl =
    (typeof connection.websocketUrl === 'string' && connection.websocketUrl) ||
    (typeof connection.url === 'string' && connection.url) ||
    undefined;
  return { ticket, websocketUrl };
}
